
<template>
  <router-btn :text="$t('servicesystem.common_objects.document.upload')" :icon="'mdi-file-plus'" :color="'quaternary'"
    :disabled="false" :outlined="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "UploadFileBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  created() { },

  mounted() { },

  methods: {
    action() {
      this.$store.dispatch("triggerevents/triggerUpload");
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
